<script lang="ts"></script>

<a class="brand" href="https://mars-host.ru" aria-label="Mars Host">
  <span class="brand-mark" aria-hidden="true"><i></i></span>
  <span class="brand-name">MARS<span>HOST</span></span>
</a>

<style>
  .brand {
    display: inline-flex;
    align-items: center;
    gap: 0.72rem;
    color: var(--cream);
    font: 700 0.92rem/1 var(--font-display);
    letter-spacing: 0.16em;
    text-decoration: none;
  }

  .brand-name > span {
    color: var(--mars-light);
  }

  .brand-mark {
    position: relative;
    display: grid;
    width: 1.95rem;
    aspect-ratio: 1;
    place-items: center;
  }

  .brand-mark::before {
    position: absolute;
    width: 1.85rem;
    height: 0.7rem;
    border: 1px solid var(--cream);
    border-radius: 50%;
    content: "";
    rotate: -22deg;
  }

  .brand-mark::after {
    position: absolute;
    top: 0.15rem;
    right: 0;
    width: 0.23rem;
    aspect-ratio: 1;
    border-radius: 50%;
    background: var(--cream);
    content: "";
  }

  .brand-mark i {
    width: 0.92rem;
    aspect-ratio: 1;
    border-radius: 50%;
    background: var(--mars);
    box-shadow: 0 0 16px rgb(214 75 50 / 0.55);
  }

  @media (max-width: 390px) {
    .brand-name {
      display: none;
    }
  }
</style>
